import { render } from "./ProductPromotionSection.vue?vue&type=template&id=2a1c8ba1&scoped=true&ts=true"
import script from "./ProductPromotionSection.vue?vue&type=script&lang=ts"
export * from "./ProductPromotionSection.vue?vue&type=script&lang=ts"

import "./ProductPromotionSection.vue?vue&type=style&index=0&id=2a1c8ba1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1c8ba1"]])

export default __exports__